"use strict";

const DEFAULT_COUNTRY_CODE = "USA";
const breadPLCCData = document.getElementById("bread-plcc-data");
const isPLCCEnabled = checkPLCCStatus();
const customerAuthenticated = isCustomerLogged();
const loginTrigger = document.getElementsByClassName("js-login-drawer-open");
const PlccAnalytics = require("storefront/analytics/analyticIndex").PlccAnalytics;
const objPlccAnalytics = new PlccAnalytics();


module.exports = {
    /**
    * Initializes the PLCC (Private Label Credit Card) integration on the client side.
    * Sets up event handlers and triggers for Bread Payments RTPS (Real-Time Pre-Screen) and BPRS (Bread Pre-Screen Response) flows,
    * including handling user authentication and tracking events. Listens for custom events on the body element to initiate
    * Bread Payments processes during checkout and landing page interactions.
    *
    * @function
    * @memberof module:plccInit
    * @returns {void}
    */
    init: function () {
        if (isPLCCEnabled) {
            let mockedStatusChangedInternally = false;

            if (breadPLCCData.dataset.mockedStatus !== "disabled") {
                mockedStatusChangedInternally = true;
            }

            plccPlacementTrigger();
            initBreadEventHandlers();
            initPlccTrackingEvent();

            if (breadPLCCData.dataset.prescreenEnabled === "true") {
                $("body").on("checkout:triggerBreadRTPS", function (_event, _data) {
                    if (customerAuthenticated) {
                        var success = breadRealtimeSetup();

                        if (success) {
                            var realTimePrescreenSetup = {
                                financingType: "card",
                                locationType: "checkout",
                            };

                            if (mockedStatusChangedInternally) {
                                realTimePrescreenSetup.mockResponse = breadPLCCData.dataset.mockedStatus;
                            }

                            window.BreadPayments.submitRtps(realTimePrescreenSetup);
                        }
                    }
                });
            }

            $("body").on("plcc:triggerBreadBPRS", function (_event, _data) {
                objPlccAnalytics.pdCollect();
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                let hasAccept = urlParams.has("accept");
                let hasPreScreenId = urlParams.has("prescreenId");
                let rtpsSetup = {
                    financingType: "card",
                    locationType: "landing",
                    customerAcceptedOffer: "true"
                };

                if (hasPreScreenId || hasAccept) {
                    if (customerAuthenticated) {
                        window.BreadPayments.submitRtps(rtpsSetup);
                    } else {
                        setTimeout(() => {
                            $(".js-login-drawer-open")[0].click();
                        }, 300);
                    }
                }
            });
        }
    }
};

/**
* Initializes and registers PLCC (Private Label Credit Card) placements on the page.
* Iterates through all elements with the "js-plcc-placement" class, gathers relevant placement data,
* and registers each placement with BreadPayments. If the customer is not authenticated,
* attaches a click event to trigger the login process when a placement is clicked.
*
* @returns {void}
*/
function plccPlacementTrigger() {
    breadPlacementsSetup();

    let placementObjs = document.getElementsByClassName("js-plcc-placement");

    for (let i = 0; i < placementObjs.length; i++) {
        const placementInfo = placementObjs[i].dataset;
        let plccPlacementData = {
            order: {
                totalPrice: breadPLCCData.dataset.orderTotal
            }
        };

        plccPlacementData.financingType = placementInfo.financingType;
        plccPlacementData.locationType = placementInfo.locationType;
        plccPlacementData.placementId = placementInfo.placementId;
        plccPlacementData.domID = placementInfo.domId;

        window.BreadPayments.registerPlacements([plccPlacementData]);

        if (!customerAuthenticated) {
            placementObjs[i].addEventListener("click", function () {
                if (loginTrigger.length > 0) {
                    loginTrigger[0].click();
                }
            });
        }
    }
}

/**
* Initializes the Bread Payments PLCC placements setup using configuration data from the global breadPLCCData object.
* If breadPLCCData is present, extracts relevant dataset attributes and calls BreadPayments.setup with the configuration.
*
* @returns {void}
*/
function breadPlacementsSetup() {
    if (breadPLCCData) {
        let setupConfig = {
            loyaltyID: breadPLCCData.dataset.loyaltyId, //optional
            storeNumber: breadPLCCData.dataset.storeNumber, //9990
            env: breadPLCCData.dataset.env, // STAGE | PROD
        };

        window.BreadPayments.setup(setupConfig);
    }
}

/**
* Initializes event handlers for BreadPayments PLCC (Private Label Credit Card) integration.
* Sets up listeners for application result, overlay content display, and overlay close events.
* Handles customer offer creation, token saving, payment information update, and dispatches custom events
* to signal PLCC application status and form start events.
*
* @returns {void}
*/
function initBreadEventHandlers() {
    if (isPLCCEnabled) {

        window.BreadPayments.on("CARD:RECEIVE_APPLICATION_RESULT", (cardResult) => {
            if (cardResult.result === "APPROVED") {
                cardResultCallback(cardResult);
            }

            window.dispatchEvent(new CustomEvent("plccFormSubmitEvent", {
                detail: {
                    customer: {
                        plccApplicationStatus: cardResult.result === "APPROVED" ? "approved" : "deferred"
                    }
                }
            }));
        });

        window.BreadPayments.on("CARD:RECEIVE_ACCOUNT_EXISTS", (cardResult) => {
            cardResultCallback(cardResult);
        });

        let pageIndex = 0;
        window.BreadPayments.on("CARD:SHOW_OVERLAY_CONTENT", () => {
            pageIndex++;

            // apply now has been clicked
            if (pageIndex === 2) {
                window.dispatchEvent(new CustomEvent("plccFormStartEvent", {}));
            }
        });

        window.BreadPayments.on("CARD:CLOSE_OVERLAY", () => { pageIndex = 0; });
    }
}

/**
* Handles the callback after receiving a card result, initiates customer offer creation,
* saves the card token in the session if available, and updates customer payment information
* if the operation is successful and the user is on the checkout page.
*
* @param {Object} cardResult - The result object returned from the card processing operation.
* @returns {void}
*/
function cardResultCallback(cardResult) {
    createCustomerOffer();

    if (cardResult.callId) {
        saveTokenInSession(cardResult.callId);
    }
}

/**
* Sends a POST request to create a customer offer using the URL specified in breadPLCCData.
* Utilizes jQuery's AJAX method to perform the request.
* @function
* @returns {void}
*/
async function createCustomerOffer() {
    return await $.ajax({ url: breadPLCCData.dataset.sendCustomerOfferUrl, method: "post" });
}

/**
* Sends an AJAX POST request to save the provided token and device type in the session.
* @param {string} token - The token to be saved in the session.
* @returns {jqXHR} A jQuery XMLHttpRequest object representing the asynchronous request.
*/
function saveTokenInSession(token) {
    return $.ajax({
        url: breadPLCCData.dataset.saveTokenInSessionUrl,
        method: "post",
        data: {
            token: token,
            device: getDeviceType(),
        },
        success: () => {
            const isCheckoutPage = $("#checkout-main").length > 0;
            if (isCheckoutPage) {
                updateCustomerPaymentInformation();
            }
        }
    });
}

/**
* Sends an AJAX request to update the customer's payment information using a backend endpoint.
*
* This function posts to the URL specified in `breadPLCCData.dataset.getCustomerPaymentInformationUrl`
* and, upon success, receives an HTML template from the backend containing the updated or preselected
* World Market credit card information. The intended use is to update the customer payment section
* in the DOM, potentially by replacing elements with the returned HTML.
*
* @function
* @returns {void}
*/
function updateCustomerPaymentInformation() {
    $.ajax({
        url: breadPLCCData.dataset.getCustomerPaymentInformationUrl,
        method: "post",
        success: result => {
            var $results = $(result);

            if ($results.length > 0) {
                var $wmCC = $(".WmCreditCard");
                var $wmRewards = $(".js-cart-rewards");
                var $newWmCC = $results.find(".js-wm-payment-container");
                var $newWmRewards = $results.find(".js-wm-rewards-container");

                if ($wmCC.length > 0) {
                    $wmCC.replaceWith($newWmCC);
                }

                if ($wmRewards.length > 0) {
                    $wmRewards.replaceWith($newWmRewards);
                }

                $(".js-is-wmcc-pre-selected").val(true);
            }
        }
    });
}

/**
* Initializes and triggers the PLCC (Private Label Credit Card) tracking event.
* Instantiates the PlccAnalytics object and collects analytics data related to PLCC interactions.
* Typically used to track user actions or events associated with PLCC features on the client side.
*
* @returns {void}
*/
function initPlccTrackingEvent() {
    objPlccAnalytics.collect();
}

/**
* Determines if the customer is currently logged in and has a loyalty ID.
* Checks if PLCC functionality is enabled, the customer is authenticated, and a loyalty ID is present.
* @returns {boolean} True if the customer is logged in and has a loyalty ID; otherwise, false.
*/
function isCustomerLogged() {
    return isPLCCEnabled && breadPLCCData.dataset.customerAuthenticated && breadPLCCData.dataset.loyaltyId.length > 0;
}

/**
* Initializes the Bread Payments PLCC integration in real-time using configuration data from the DOM.
* Retrieves necessary data attributes from the global breadPLCCData object, constructs a configuration object,
* and invokes the BreadPayments.setup method to enable PLCC functionality.
*
* @returns {void}
*/
function breadRealtimeSetup() {
    if (breadPLCCData) {
        var buyerInformation = getBuyerInformation();

        if (!buyerInformation || isInvalidShippingAddress(buyerInformation)) {
            return false;
        }

        let setupConfig = {
            loyaltyID: breadPLCCData.dataset.loyaltyId,
            storeNumber: breadPLCCData.dataset.storeNumber,
            env: breadPLCCData.dataset.env,
            buyer: buyerInformation
        };

        window.BreadPayments.setup(setupConfig);
        return true;
    }
}

/**
* Retrieves buyer information from the shipping form on the page.
*
* Extracts the buyer's first name, last name, email, phone number, and billing address details
* from the DOM elements within the shipping form. The phone number is sanitized to contain only digits.
*
* @returns {Object} An object containing the buyer's information:
*   @property {string} givenName - Buyer's first name.
*   @property {string} familyName - Buyer's last name.
*   @property {string} email - Buyer's email address, sourced from breadPLCCData dataset.
*   @property {string} phone - Buyer's phone number (digits only).
*   @property {Object} billingAddress - Buyer's billing address details:
*     @property {string} billingAddress.address1 - First line of the address.
*     @property {string} billingAddress.country - Country code (uses DEFAULT_COUNTRY_CODE).
*     @property {string} billingAddress.locality - City or locality.
*     @property {string} billingAddress.region - State or region.
*     @property {string} billingAddress.postalCode - Postal or ZIP code.
*/
function getBuyerInformation() {
    const multiShippingForm = document.getElementsByClassName("js-multi-shipping-address-form");
    const shippingEl = multiShippingForm.length > 0
        ? multiShippingForm[0]
        : document.getElementById("dwfrm_shipping");

    if (shippingEl) {
        return {
            givenName: shippingEl.getElementsByClassName("shippingFirstName")[0].value,
            familyName: shippingEl.getElementsByClassName("shippingLastName")[0].value,
            email: breadPLCCData.dataset.email,
            phone: shippingEl.getElementsByClassName("shippingPhoneNumber")[0].value.replace(/\D/g, ""),
            billingAddress: {
                address1: shippingEl.getElementsByClassName("shippingAddressOne")[0].value,
                // address2: shippingEl.getElementsByClassName("shippingAddressTwo")[0].value,
                country: DEFAULT_COUNTRY_CODE,
                locality: shippingEl.getElementsByClassName("shippingAddressCity")[0].value,
                region: shippingEl.getElementsByClassName("shippingState")[0].value,
                postalCode: shippingEl.getElementsByClassName("shippingZipCode")[0].value
            }
        };
    }

    const isBopisOrder = $("#isPickupInStore").val() === "true" && $("#isPickupAndShipping").val() === "false";

    if (isBopisOrder) {
        var customerSavedAddress = breadPLCCData.dataset.customerAddress ? JSON.parse(breadPLCCData.dataset.customerAddress) : null;

        if (customerSavedAddress) {
            return {
                givenName: breadPLCCData.dataset.firstName,
                familyName: breadPLCCData.dataset.lastName,
                email: breadPLCCData.dataset.email,
                phone: breadPLCCData.dataset.phone,
                billingAddress: {
                    address1: customerSavedAddress && customerSavedAddress.address1,
                    country: DEFAULT_COUNTRY_CODE,
                    locality: customerSavedAddress && customerSavedAddress.locality,
                    region: customerSavedAddress && customerSavedAddress.region,
                    postalCode: customerSavedAddress && customerSavedAddress.postalCode
                }
            };
        }
    }

    return null;
}

/**
* Checks if the provided buyer information contains any invalid or missing shipping address fields.
* @param {Object} buyerInformation - The buyer's information object containing personal and billing address details.
* @returns {boolean} Returns true if any required field is missing or empty; otherwise, false.
*/
function isInvalidShippingAddress(buyerInformation) {
    return buyerInformation.givenName.length === 0 ||
        buyerInformation.familyName.length === 0 ||
        buyerInformation.email.length === 0 ||
        buyerInformation.phone.length === 0 ||
        buyerInformation.billingAddress.address1.length === 0 ||
        buyerInformation.billingAddress.country.length === 0 ||
        buyerInformation.billingAddress.locality.length === 0 ||
        buyerInformation.billingAddress.region.length === 0 ||
        buyerInformation.billingAddress.postalCode.length === 0;
}

/**
* Checks if the Bread Payments PLCC integration is enabled and data is available.
* @returns {boolean} - Returns true if both the BreadPayments object exists on the window and breadPLCCData is defined; otherwise, returns false.
*/
function checkPLCCStatus() {
    return window.BreadPayments && breadPLCCData ? true : false;
}

/**
* Determines the current device type based on the window width using predefined breakpoints.
* Returns "mobile" if the viewport width is 767px or less, otherwise returns "desktop".
* This function is used to distinguish between mobile and desktop devices for PLCC requirements.
*
* @returns {string} The detected device type: either "mobile" or "desktop".
*/
function getDeviceType() {
    // PLCC requires to pass mobile or anything else, as such there are just 2 breakpoints defined
    const breakpoints = {
        mobile: "(max-width: 767px)",
        desktop: "(min-width: 768px)"
    };

    // Check the media queries against the window width
    for (const device in breakpoints) {
        if (window.matchMedia(breakpoints[device]).matches) {
            return device;
        }
    }

    // Default to desktop if no breakpoint matches
    return "desktop";
}
